import { useState } from "react";
import { genres } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function GenreBrowse() {
  const [active, setActive] = useState(genres[0].id);
  const activeGenre = genres.find((g) => g.id === active) ?? genres[0];

  return (
    <section id="genres" className="w-full bg-background-50 px-4 py-10 md:px-6 md:py-14">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          eyebrow="Browse By Genre"
          title="按题材索引，锁定你想看的那一类"
          desc="从热血战斗到治愈温情，12 个高频题材一路排开。点一下就能看到该题材下的作品数量与代表作。"
          actionText="全部题材合集"
        />

        <div className="flex flex-wrap gap-2.5 md:gap-3">
          {genres.map((genre) => (
            <button
              key={genre.id}
              type="button"
              onClick={() => setActive(genre.id)}
              className={`flex items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors cursor-pointer ${
                active === genre.id
                  ? "border-secondary-500 bg-secondary-500 text-background-50"
                  : "border-background-300 bg-background-100 text-foreground-700 hover:border-secondary-300 hover:text-secondary-800"
              }`}
            >
              {genre.name}
              <span className={`text-[11px] ${active === genre.id ? "text-background-100" : "text-foreground-400"}`}>
                {genre.count}
              </span>
            </button>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-500 text-background-50">
              <i className="ri-layout-grid-line text-xl" />
            </span>
            <div>
              <p className="font-heading text-base font-bold text-foreground-950">
                当前题材：{activeGenre.name}
              </p>
              <p className="text-xs text-foreground-500">
                已收录 <span className="font-semibold text-secondary-700">{activeGenre.count}</span> 部作品，含高分与完结作品
              </p>
            </div>
          </div>
          <a
            href="#collections"
            className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
          >
            <i className="ri-arrow-right-line text-base" />
            浏览该题材合集
          </a>
        </div>
      </div>
    </section>
  );
}